// src/layout/DocsLayout.jsx
import { Box, IconButton, Drawer, useMediaQuery, Typography, } from '@mui/material';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import DocsSidebar from 'components/DocsSidebar';
import Footer from 'components/Footer';
import DocsBreadcrumbs from 'components/DocsBreadcrumbs';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import SmokeFreeIcon from '@mui/icons-material/SmokeFree';

const DocsLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <>
      <Box sx={{ display: 'flex', minHeight: 'calc(100vh - 235px)', scrollBehavior: 'smooth', }}>
        {/* ✅ 데스크탑 전용 사이드바 */}
        {!isMobile && (
          <Box
            sx={{
              width: 220,
              p: 2,
              mt: 10,
              position: 'relative',
              height: 'calc(100vh - 235px)',
              overflowY: 'auto',
              transition: 'width 0.3s ease',
              ml: { xs: 2, sm: 3, md: '6%' },
            }}
          >
            <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ml:4}}>
        📚 명령어
      </Typography>
            <DocsSidebar />
          </Box>
        )}

        {/* ✅ 본문 + 푸터 */}
        <Box
          component="main"
          sx={{
            width: {xs:'100%'},
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: {xs:'center', md:'flex-start'},
            minHeight: 'calc(100vh - 235px)',
            pl: { xs: 3 , sm: 3, md: 4 },
            pr: { xs: 3, sm: 3, md: 4 },
          }}
        >
          {/* ✅ 모바일 전용 Drawer */}
          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            PaperProps={{
              elevation: 0,
              sx: {
                backgroundColor: theme.palette.background.paper,
                width: 230,
                padding: 0,
                alignItems: 'stretch',
              },
            }}
          >
            <Box sx={{backgroundColor: theme.palette.background.paper, mt: 6, p: 0 }}>
              <DocsSidebar onLinkClick={() => setDrawerOpen(false)} />
            </Box>
          </Drawer>
          {/* ✅ 본문 내용 */}
          <Box sx={{ 
            flex: '1 0 auto',
            px: { xs: 0, sm: 4, md: 4 },
            pt: '80px',
            mt: { xs: 0, sm: 0, md: 6,},
            pb: 4,
            scrollMarginTop: '80px',
            justifyContent:'center',
           }}
            >
            <DocsBreadcrumbs />
            {children}
            {isMobile && (
              <Box
                sx={{
                mt:5,
              }}>
              <DocsSidebar /></Box>
            )}
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default DocsLayout;
